import { Form, Modal, notification, Select } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import {
  changeTutorialVisibility,
  getTutorialById,
} from "store/slices/tutorialsSlice";

const EditTutorialVisibilityModal = () => {
  const { t } = useTranslation();
  const [form] = Form?.useForm();
  const dispatch = useDispatch();
  const { isModalOpen, modalType, modalProps } = useSelector(
    (state) => state?.modals
  );
  const { tutorial, loading } = useSelector((state) => state?.tutorials);
  const open = isModalOpen && modalType === "edit_tutorial_visibility";

  useEffect(() => {
    if (open && modalProps?.tutorialId) {
      dispatch(getTutorialById(modalProps?.tutorialId));
    }
  }, [dispatch, modalProps?.tutorialId, open]);

  useEffect(() => {
    if (tutorial && open) {
      form?.setFieldsValue({
        visibility: tutorial?.visibility,
      });
    }
  }, [form, tutorial, open]);

  const handleCancel = () => {
    form?.resetFields();
    dispatch(closeModal());
  };

  const handleOk = async () => {
    try {
      const values = await form?.validateFields();
      await dispatch(
        changeTutorialVisibility({
          id: modalProps?.tutorialId,
          visibility: values?.visibility,
        })
      )?.unwrap();

      notification?.success({
        message: t("tutorials.crud.form.visibility.success"),
        duration: 3,
      });
      handleCancel();
    } catch (error) {
      notification?.error({
        message: t("tutorials.crud.form.visibility.error"),
        description: error?.message || t("common.error.generic"),
        duration: 4,
      });
    }
  };

  return (
    <Modal
      title={t("tutorials.crud.form.visibility.title")}
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      destroyOnClose={true}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="visibility"
          label={t("tutorials.crud.form.label.visibility")}
          rules={[
            {
              required: true,
              message: t("tutorials.crud.form.visibility.required"),
            },
          ]}
        >
          <Select>
            <Select.Option value="public">
              {t("tutorials.visibility.public")}
            </Select.Option>
            <Select.Option value="private">
              {t("tutorials.visibility.private")}
            </Select.Option>
            <Select.Option value="premium">
              {t("tutorials.visibility.premium")}
            </Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditTutorialVisibilityModal;
